import {observer} from 'mobx-react';
import {useStores} from '../../../../../hooks';
import {Alert, AlertTitle} from '@material-ui/lab';
import {Space} from '../../../../../common/components/libs';
import React from 'react';

const TariffWarningMessage = () => {
    const { authStore } = useStores()

    if (!authStore.isTariffOverdue()) return null

    return <>
        <Alert severity={'warning'}>
            <AlertTitle>Тариф просрочен</AlertTitle>
            До отключения ваших меню {authStore.menusAliveStr()}
        </Alert>
        <Space size={8}/>
    </>
}

export default observer(TariffWarningMessage)